module.exports = fox._r("fonts/woodfordbourne-italic-webfont.ttf", __webpack_public_path__ + "fonts/18EBqYn.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/woodfordbourne-italic-webfont.ttf
// module id = 7
// module chunks = 5